import React from 'react'

import { StarbucksEligibilityErrorMessage } from './StarbucksEligibilityErrorMessage'
import { InlineErrorBanner } from '../../../molecules'

export const StarbucksEligibilityErrorBanner: React.FC<{ isDependent: boolean }> = ({ isDependent }) => {
  return (
    <InlineErrorBanner
      text={<StarbucksEligibilityErrorMessage />}
      testId={`EmployeeInfoFor${isDependent ? 'Dependent' : 'Employee'}Eligibility-tips`}
    />
  )
}
